import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

const confirmDialog = (title, message, func) =>
  confirmAlert({
    title: title,
    message: message,
    buttons: [
      {
        label: "Yes",
        onClick: func,
      },
      {
        label: "No",
      },
    ],
  });

const notifyDialog = (title, message, func) =>
  confirmAlert({
    title: title,
    message: message,
    buttons: [
      {
        label: "Ok",
        onClick: func,
      },
    ],
  });

export { confirmDialog, notifyDialog };
